import { useMutation } from "urql";

import { ApproveRestructureDocument } from "../../../graphql/generated.ts";

export function useApproveRestructure() {
  return useMutation(ApproveRestructureDocument);
}
